module.exports = __webpack_public_path__ + "assets/images/pages/job/feature-default.png?c226be04";